import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

/**
 * Footer component for the application
 * Displays copyright information and links
 */
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark text-light py-3 mt-auto">
      <Container>
        <Row>
          <Col className="text-center">
            <p className="mb-0">
              &copy; {currentYear} Stanley D Karaoke. All rights reserved.
            </p>
            <p className="small mb-0">
              <a href="#" className="text-light text-decoration-none mx-2">Privacy Policy</a>
              <span className="mx-1">|</span>
              <a href="#" className="text-light text-decoration-none mx-2">Terms of Service</a>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

// Export the component as default
export default Footer;
